import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  permitTemplateKeys,
  RequestTypes,
} from '@core/react-query/features/templates/permitTemplates/permitTemplate'
import { projectsKeys } from '@core/react-query/features/projects'

export const useRemoveProjectsFromTemplate = (
  options?: UseMutationOptions<
    unknown,
    string,
    RequestTypes['removeProjectsFromTemplate']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...permitTemplateKeys.removeProjectsFromTemplate,
    ...options,
    onSuccess: () => {
      queryClient.invalidateQueries(projectsKeys._def)
    },
  })
}
